import { combineEpics } from 'redux-observable';

import { datadogRUMEpic } from './datadog.epic';
import { loadAnalyticsDataEpic } from './load-analytics-data.epic';
import { logRocketIdentifyEpic, logRocketInitEpic } from './logrocket.epic';
import { createSignupEpic } from './partner-stack.epic';
import { segmentAnalyticsEpic } from './segment-analytics.epic';
import { statsigEpic } from './statsig.epic';
import { LOGROCKET_ENABLED } from '../../../env';

let analyticsEpic = combineEpics(
  datadogRUMEpic,
  segmentAnalyticsEpic,
  statsigEpic,
  loadAnalyticsDataEpic,
  createSignupEpic,
);

if (LOGROCKET_ENABLED) {
  analyticsEpic = combineEpics(analyticsEpic, logRocketInitEpic, logRocketIdentifyEpic);
}

export { analyticsEpic };
